
import React, { useEffect, useCallback, useState } from "react";
import Select from "react-select";
import { fetchProduit, produitAdded } from "../../../Redux/produitReduce";
import {
    AddedExcel,
    saveFile,
    checkProduit,
    verifEntete,
} from "../../../Redux/extractionReduce";
import { useDispatch } from "react-redux";
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { verif } from "./verif_PP";
import { toast, ToastContainer } from "react-toastify";
import { useHistory, useParams } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import { fetchAnnee } from "../../../Redux/anneeReduce";

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';



function extraction_PP({ client }) {

    const navigate = useHistory();
    const dispatch = useDispatch();

    const [variable, setVariable] = React.useState("");
    const [alert, setAlert] = React.useState(null);
    const [isLoading, setIsLoading] = React.useState(0);
    const [parent, setparent] = React.useState(0);
    const [entities, setEntities] = useState([]);
    const [uploadFile, setUploadFile] = React.useState()
    const [fileName, setFileName] = useState("");
    const [month, setmonth] = React.useState(0);
    const [year, setyear] = React.useState(0);
    const [readonly, setreadonly] = React.useState(0);


    const notify = (type, msg) => {
        if (type === 1)
            toast.success(<strong>{msg}</strong>);
        else
            toast.error(<strong>{msg}</strong>);
    }

    //Produit
    const [produitSelect, setProduitSelect] = React.useState([]);
    const [optionProduit, setOptionProduit] = React.useState([
        {
            value: "",
            label: "Produit",
            isDisabled: true,
        },
    ]);

    //parent
    const [optionsPP, setPPOptions] = React.useState([
        {
            value: "",
            label: "veuillez choisir un parent",
            isDisabled: true,
            style: "placeholder",
        },
    ]);
    const [PPSelect, setPPSelect] = React.useState({
        value: 0,
        label: "veuillez choisir un parent",
        style: "placeholder",
    });

    //mois
    const [optionsmois, setmoisOptions] = React.useState([
        {
            value: "",
            label: "veuillez choisir un mois",
            isDisabled: true,
            style: "placeholder",
        },
    ]);
    const [moisSelect, setmoisSelect] = React.useState({
        value: 0,
        label: "veuillez choisir un mois",
        style: "placeholder",
    });

    //annee
    const [anneeSelect, setanneeSelect] = React.useState({
        value: 0,
        label: "veuillez choisir une année",
        style: "placeholder",
    });
    const [optionsannee, setanneeOptions] = React.useState([
        {
            value: "",
            label: "veuillez choisir une année",
            isDisabled: true,
            style: "placeholder",
        },
    ]);



    const verifmois = useCallback(
        async (b) => {

            var entities = [
                { id: 1, nom: "Janvier" }, { id: 2, nom: "Février" }, { id: 3, nom: "Mars" },
                { id: 4, nom: "Avril" }, { id: 5, nom: "Mai" }, { id: 6, nom: "Juin" },
                { id: 7, nom: "Juillet" }, { id: 8, nom: "Aout" }, { id: 9, nom: "septembre" },
                { id: 10, nom: "Octobre" }, { id: 11, nom: "Novembre" }, { id: 12, nom: "Décembre" },
            ]
            var arOption = [];
            arOption.push({ value: 0, label: "veuillez choisir un mois", style: "placeholder" });
            entities.forEach((a) => {
                arOption.push({ value: a.id, label: a.nom });
                if (a.id === b) {
                    setmoisSelect({ value: a.id, label: a.nom });
                    setmonth(a.id);
                }
            });
            setmoisOptions(arOption);
        },
        [dispatch]
    );


    const verifannee = useCallback(
        async (b) => {
            var PP = await dispatch(fetchAnnee());
            var entities = PP.payload;
            var arOption = [];
            arOption.push({ value: 0, label: "veuillez choisir une année", style: "placeholder" });
            const currentYear = new Date().getFullYear();
            entities.forEach((a, index) => {
                arOption.push({ value: a.id, label: a.annee });

                //if (index === entities.length - 1) {
                if (currentYear === parseInt(a.annee)) {
                    setanneeSelect({ value: a.id, label: a.annee });
                    setyear(a.annee);
                }
                //}
            });
            setanneeOptions(arOption);
        },
        [dispatch]
    );



const exportToexcel = async (info) => {
    const name = "Exemple excel prix produit";
    const currentDate = new Date();

    const formattedDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate()
        .toString()
        .padStart(2, '0')}`;

    const fileName = `${name} ${formattedDate}`;

    if (!info || info.length === 0) return;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('data');

    // Create columns based on object keys
    const headers = Object.keys(info[0]);

    worksheet.columns = headers.map((header) => ({
        header: header,
        key: header,
        width: 20,
    }));

    // Add rows
    info.forEach((row) => {
        worksheet.addRow(row);
    });

    // Bold header row
    worksheet.getRow(1).font = { bold: true };

    // Auto adjust column width
    worksheet.columns.forEach((column) => {
        let maxLength = 10;
        column.eachCell({ includeEmpty: true }, (cell) => {
            const length = cell.value ? cell.value.toString().length : 10;
            if (length > maxLength) {
                maxLength = length;
            }
        });
        column.width = maxLength + 2;
    });

    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    saveAs(blob, `${fileName}.xlsx`);
};



    const fileHandler = (e) => {
        let fileObj = e.target.files[0];
        if (fileObj) {
            setUploadFile(fileObj);
            var str = fileObj.name.replace(/[^a-zA-Z0-9,;\-.!? ]/g, "");
            setFileName(str);
        }
    };


    const showTable = useCallback(async () => {
        try {
            if (fileName !== "") {
                const verificationResult = await dispatch(
                    verifEntete({
                        date: year,
                        month: month,
                        fileName: fileName,
                        id_site: client == "/medis" ? 2 : 3
                    })
                );

                if (verificationResult.payload === false) {
                            const arrayBody = await new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = async (e) => {
        try {
            const buffer = e.target.result;

            const workbook = new ExcelJS.Workbook();
            await workbook.xlsx.load(buffer);

            const worksheet = workbook.worksheets[0]; // First sheet

            const rows = [];

            worksheet.eachRow({ includeEmpty: true }, (row) => {
                // ExcelJS row.values starts at index 1
                const rowData = row.values.slice(1);
                rows.push(rowData);
            });

            resolve(verif(rows, month, anneeSelect.label));
        } catch (err) {
            console.error("Error reading Excel file:", err);
            reject(err);
        }
    };

    reader.onerror = (err) => reject(err);

    reader.readAsArrayBuffer(uploadFile);
});


                    if (arrayBody.test === false) {
                        notify(2, "Vérifier les champs de votre fichier excel");
                        window.location.reload();
                    } else {
                        notify(1, "Extraction avec succès");
                        checkProd(arrayBody.array, year);
                    }
                } else {
                    notify(2, "Déjà inséré");
                    setreadonly(0);
                    setIsLoading(0);
                    setBoutonClique(false);
                }
            } else {
                notify(2, "Vérifiez vos données");
            }
        } catch (error) {
            console.error("An error occurred:", error);
        }
    }, [dispatch, fileName]);



    const getproduit = useCallback(async () => {
        var type = await dispatch(fetchProduit({ client }));
        var entities = type.payload;
        var arrayOption = [];
        entities.forEach((e) => {
            arrayOption.push({ value: e.id, label: e.Designation_1, code: e.Code_PCT });
        });
        setOptionProduit(arrayOption);
    }, [dispatch]);



    function deleteLigne(nb) {
        if (entities.length > 1) {
            // Filter produitSelect
            var filteredProduitSelect = produitSelect.filter(function (value, index) {
                return index !== parseInt(nb);
            });

            // Filter entities
            var filteredEntities = entities.filter(function (entity, index) {
                return index !== parseInt(nb);
            });

            setProduitSelect(filteredProduitSelect);
            setEntities(filteredEntities);
            notify(2, "Supprimer avec succès");
        } else {
            notify(2, "Il faut contenir au moins une ligne");
        }
    }


    const checkProd = useCallback(
        async (table, year) => {
            var arrayBody = [];
            dispatch(checkProduit({ table, year })).then((rowsdes) => {
                if (rowsdes !== undefined && rowsdes.payload.length > 0) {
                    var prod = rowsdes.payload;
                    // console.log(table)
                    for (var i = 0; i < prod.length; i++) {
                        // console.log("ggg", prod[i],i)
                        if (
                            prod[i] !== null &&
                            typeof prod[i] !== "undefined" &&
                            prod[i] !== "undefined"
                        ) {
                            // console.log("des", table[i].designation, i)
                            arrayBody.push({
                                idProduit: prod[i][2],
                                designation: prod[i][0],
                                code: prod[i][3],
                                prix: prod[i][4],
                            });
                        }
                        else {
                            // console.log("des", table[i].designation, i)
                            // arrayBody.push({
                            //     idProduit: null,
                            //     designation: table[i].designation,
                            //     code: table[i].code,
                            //     prix: table[i].prix,
                            // });
                        }
                    }
                    // console.log(arrayBody)
                    setEntities(arrayBody);
                    setIsLoading(2);
                } else {
                    setEntities([]);
                }
            })
        },
        [dispatch]
    );


    const setTable = useCallback(
        async (table, init) => {
            //1 => update table ***** 0 => initialiser table
            var arrayBody = [];
            if (init === 1) {
                table.forEach((value) => {
                    arrayBody.push({
                        idProduit: value.idProduit,
                        designation: value.designation,
                        code: value.code,
                        prix: value.prix,
                    });
                });
                setEntities(arrayBody);
            } else {
                checkProd(table, year);
            }
        },
        [checkProd]
    );


    const removeProduit = useCallback(
        async (list, select, id) => {
            // console.log(list,select,id)
            list[id].idProduit = null;
            list[id].designation = null;
            list[id].code = "";
            select[id] = null;
            setProduitSelect(select);
            setEntities(list);
            setTable(list, 1);

            console.log(entities)
        },
        [setTable]
    );


    const saveTable = useCallback(async (entities, uploadFile, year, month, client) => {

        if (!verifierLigne(entities)) {
            return;
        }

        var verif = true;
        if (entities.length > 0) {
            entities.forEach((data) => {
                if (data.idProduit === null) verif = false;
            });
        } else {
            verif = false;
        }
        if (verif === false) {
            notify(2, "Vérifier vos données!");
        } else {
            const dataArray = new FormData();
            dataArray.append("file", uploadFile);
            dataArray.append("name", uploadFile.name);

            dispatch(saveFile(dataArray)).then((e) => {
                var filename = e.payload.filename;

                dispatch(
                    AddedExcel({
                        annee: year,
                        mois: month,
                        file: filename,
                        namefile: uploadFile.name,
                        lignes: entities, client
                    })
                ).then((e) => {
                    if (e.payload === true) {
                        notify(1, "Insertion avec succes");
                        setTimeout(() => {
                            window.location.reload();
                        }, 1300);
                    } else {
                        notify(2, "Vérifier vos données!");
                    }
                });
            });
        }
    },
        [dispatch]
    );


    function verifierLigne(entities) {

        var idProduitSet = new Set();

        for (var i = 0; i < entities.length; i++) {
            var line = entities[i];

            if (line.idProduit === null) {
                notify(2, "Veuillez choisir un produit " + (i + 1));
                return;
            }

            if (idProduitSet.has(line.idProduit)) {
                notify(2, "Le produit " + line.designation + " est dupliqué ");
                return false;
            }

            idProduitSet.add(line.idProduit);


            if (line.code === null) {
                notify(2, "Veuillez choisir un code " + (i + 1));
                return;
            }

            if (line.prix === null) {
                notify(2, "Veuillez saisir un prix " + (i + 1));
                return;
            }


        }


        return true;
    }


    function AjoutLigne(event) {
        var list = [];
        if (entities.length > 0) list = [...entities];
        list[list.length] = {
            idProduit: null,
            designation: null,
            code: null,
            prix: null
        };
        setEntities(list);
    }


    function listepp() {
        navigate.push(client + "/listPP");
    }


    const ProdParent = useCallback(
        async (b) => {
            var PP = await dispatch(fetchProduit());
            var entities = PP.payload;
            var arOption = [];
            arOption.push({ value: 0, label: "veuillez choisir un parent", style: "placeholder" });
            entities.forEach((a) => {
                arOption.push({ value: a.id, label: a.designation });
                if (a.id === b) {
                    setPPSelect({ value: a.id, label: a.designation });
                    setparent(a.id);
                }
            });
            setPPOptions(arOption);
        },
        [dispatch]
    );



    const confirm = (entities, produit, index) => {
        // console.log(entities[index])

        localStorage.setItem("nom", entities[index].designation);
        localStorage.setItem("parent", "");
        localStorage.setItem("code", entities[index].code);

        setAlert(
            <SweetAlert
                style={{ display: "block", marginTop: "-100px" }}
                title="Ajout produit"
                onConfirm={() => submitProd(entities, produit, index)}
                onCancel={() => hideAlert()}
                confirmBtnBsStyle="info"
                cancelBtnBsStyle="danger"
                confirmBtnText="Oui"
                cancelBtnText="Non"
                showCancel
            >

                <div>
                    <Form.Group className="input-comment">
                        <label>Désignation</label>
                        <Form.Control
                            className="form-control"
                            value={entities[index].designation}
                            onChange={(value) => {
                                localStorage.setItem("nom", value.target.value);
                            }}
                            rows="5"
                        ></Form.Control>
                    </Form.Group>
                </div>
                {/* <div >
                    <Form.Group >
                        <label>Parent</label>
                        <Select
                            className="select"
                            onChange={(value) => {
                                setPPSelect(value);
                                setparent(value.value);
                                localStorage.setItem("parent", value.value);
                            }}
                            options={optionsPP}
                        />
                    </Form.Group>
                </div> */}
                <div>
                    <Form.Group className="input-comment">
                        <label>Code</label>
                        <Form.Control
                            className="form-control"
                            value={entities[index].code}
                            onChange={(value) => {
                                localStorage.setItem("code", value.target.value);
                            }}
                            rows="5"
                        ></Form.Control>
                    </Form.Group>
                </div>
            </SweetAlert>
        );
    }



    const submitProd = (entities, produit, index) => {
        var nom = localStorage.getItem("nom");
        var code = localStorage.getItem("code");
        var parent = localStorage.getItem("parent");
        dispatch(
            produitAdded({
                id: 0, nom: nom, code: code, parent: parent
            })
        ).then((value) => {
            hideAlert();
            if (value.payload.msg === true) {

                const newProduct = {
                    value: value.payload.id,
                    label: nom,
                    code: code,
                };


                const updatedProduitSelect = [...produitSelect];
                updatedProduitSelect[index] = newProduct;
                setProduitSelect(updatedProduitSelect);

                const updatedEntities = [...entities];
                updatedEntities[index].designation = nom;
                updatedEntities[index].code = code;
                updatedEntities[index].idProduit = value.payload.id
                setEntities(updatedEntities);

                const listOption = [...optionProduit];
                listOption.push(newProduct);
                setOptionProduit(listOption);
            } else {
                notify(2, "Problème de connexion");
            }
        });
    };



    const hideAlert = () => {
        setAlert(null);
    };



    useEffect(() => {
        switch (month) {
            case 1:
                setVariable("JANVIER");
                break;
            case 2:
                setVariable("FEVRIER");
                break;
            case 3:
                setVariable("MARS");
                break;
            case 4:
                setVariable("AVRIL");
                break;
            case 5:
                setVariable("MAI");
                break;
            case 6:
                setVariable("JUIN");
                break;
            case 7:
                setVariable("JUILLET");
                break;
            case 8:
                setVariable("AOUT");
                break;
            case 9:
                setVariable("SEPTEMBRE");
                break;
            case 10:
                setVariable("OCTOBRE");
                break;
            case 11:
                setVariable("NOUVEMBRE");
                break;
            case 12:
                setVariable("DECEMBRE");
                break;
            default:
                break;
        }
        getproduit();
        ProdParent(0)
        verifmois()
        verifannee()
    }, []);


    function deleteLigne(id, entities) {
        var list = [...entities];
        if (list.length > 1) {
            entities.splice(parseInt(id), 1);
            setEntities(entities);
            notify(1, "Supprimer avec succes");
        } else {
            notify(2, "il faut contient au moins une ligne");
        }
        hideAlert();
    }


    const confirmMessage = (id, entities) => {
        setAlert(
            <SweetAlert
                style={{ display: "block", marginTop: "-100px" }}
                title="Êtes-vous sûr de supprimer cette ligne ?"
                onConfirm={() => deleteLigne(id, entities)}
                onCancel={() => hideAlert()}
                confirmBtnBsStyle="info"
                cancelBtnBsStyle="danger"
                confirmBtnText="Oui"
                cancelBtnText="Non"
                showCancel
            ></SweetAlert>
        );
    };


    return (

        <>
            <Container fluid className="responsive-BL table-dynamique releve-class">
                <ToastContainer />
                {alert}
                <Row>
                    <Col md="12">
                        <Button
                            id="saveBL"
                            className="btn-wd btn-outline mr-1 float-left"
                            type="button"
                            variant="info"
                            onClick={listepp}
                        >
                            <span className="btn-label">
                                <i className="fas fa-list"></i>
                            </span>
                            Retour à la liste
                        </Button>
                    </Col>


                </Row>

                <Row>
                    <Col md="12">
                        <Card className="strpied-tabled-with-hover">
                            <Card.Header>
                                <Card.Title as="h3" style={{ textAlign: "center", color: "#0077af" }}><strong>{variable}</strong> </Card.Title>
                                <Row>
                                    <Col md="10">
                                        <Card.Title as="h4">Prix produit</Card.Title>
                                    </Col>
                                    <Col md="2">
                                        <Button
                                            id="saveBL"
                                            className="btn-wd btn-outline mr-1 float-left"
                                            type="button"
                                            variant="info"
                                            onClick={() => {
                                                const currentDate = new Date();
                                                const currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, '0');
                                                const currentYear = currentDate.getFullYear();
                                                const dynamicKey = `${currentMonth}.${currentYear}`;
                                                exportToexcel([{ "Dp_Code_B": "", "Drug_Product_B": "", [dynamicKey]: "" }]);
                                            }}
                                        >
                                            <span className="btn-label">
                                                <i className="fas fa-upload"></i>
                                            </span>
                                            Télécharger exemple
                                        </Button>
                                    </Col>
                                </Row>

                            </Card.Header>
                            <Card.Body>



                                <Row>
                                    <Col className="pl-1" md="6">
                                        <Form.Group >
                                            <label>Mois</label>
                                            <Select
                                                placeholder="Mois "
                                                className="react-select primary "
                                                classNamePrefix="react-select"
                                                isDisabled={readonly === 1}
                                                value={moisSelect}
                                                onChange={(value) => {
                                                    setmoisSelect(value);
                                                    setmonth(value.value);
                                                }}
                                                options={optionsmois}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col className="pl-1" md="6">
                                        <Form.Group >
                                            <label>Année</label>
                                            <Select
                                                placeholder="Année "
                                                className="react-select primary "
                                                classNamePrefix="react-select"
                                                value={anneeSelect}
                                                isDisabled={readonly === 1}
                                                onChange={(value) => {
                                                    setanneeSelect(value);
                                                    setyear(value.value);
                                                }}
                                                options={optionsannee}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <br></br><br></br>

                                <Form.Group  >
                                    <Form.Control
                                        id="test"
                                        name="file"
                                        type="file" isDisabled={readonly === 1}
                                        accept=".xls, .xlsx"
                                        onChange={(e) => {
                                            fileHandler(e);
                                        }}
                                    ></Form.Control>
                                </Form.Group>

                                {/* <div className="custom-file">
                                    <input
                                        type="file"
                                        className="custom-file-input"
                                        id="inputGroupFile01"
                                        aria-describedby="inputGroupFileAddon01"
                                        isDisabled={readonly === 1}
                                        accept=".xls, .xlsx"
                                        onChange={(e) => {
                                            fileHandler(e);
                                        }}
                                    />
                                    <label className="custom-file-label">{fileName}</label>
                                </div> */}

                                <br></br>
                                <br></br>
                                <div className="text-center" style={{ display: month != 0 && fileName != "" ? 'block' : 'none' }}>
                                    <Button
                                        className="btn-wd btn-outline mr-1 float-right extraction"
                                        id="blExt"
                                        type="button"
                                        variant="info"
                                        style={{ display: readonly === 0 ? 'block' : 'none' }}
                                        onClick={(v) => {
                                            showTable();
                                            setIsLoading(1)
                                            setreadonly(1)
                                        }}
                                    >
                                        <span className="btn-label">
                                            <i className="fas fa-cogs"></i>
                                        </span>
                                        Extraction
                                    </Button>
                                </div>


                                <div className="loader-container" style={{ display: isLoading === 1 ? 'block' : 'none' }}>
                                    <div className="loader"></div>
                                </div>

                                <Row style={{ display: isLoading === 2 ? 'block' : 'none' }} >
                                    <Col md="12">
                                        <hr></hr>
                                        <br></br>





                                        {/* //New */}

                                        <div className="div-sample1">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th>Designation</th>
                                                        <th>Code</th>
                                                        <th>Prix</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {/* {console.log(entities)} */}
                                                    {entities.map((row, key) => (

                                                        <tr key={"tr-" + key}>

                                                            <td>

                                                                {row.idProduit !== null ? (
                                                                    <Form.Group className="desinationProduit">
                                                                        <Form.Control
                                                                            className="green"
                                                                            readOnly
                                                                            value={row.designation}
                                                                            placeholder="Designation"
                                                                            type="text"
                                                                        />
                                                                        <Button
                                                                            onClick={() => {
                                                                                removeProduit(entities, produitSelect, key);
                                                                            }}
                                                                        >
                                                                            <i className="fa fa-trash" />
                                                                        </Button>
                                                                    </Form.Group>
                                                                ) : (
                                                                    <div >
                                                                        {row.designation != null ? (
                                                                            <Form.Group className="desinationProduit">
                                                                                <Form.Control
                                                                                    className="red"
                                                                                    readOnly
                                                                                    value={row.designation}
                                                                                    placeholder="Designation"
                                                                                    type="text"
                                                                                />
                                                                                <Button
                                                                                    onClick={() => {
                                                                                        removeProduit(entities, produitSelect, key);
                                                                                    }}
                                                                                >
                                                                                    <i className="fa fa-trash" />
                                                                                </Button>
                                                                            </Form.Group>
                                                                        ) : (
                                                                            ''
                                                                        )}
                                                                        <Select
                                                                            className="react-select primary custom-react-select"
                                                                            classNamePrefix="react-select"
                                                                            name="Produit"
                                                                            placeholder="Produit"
                                                                            value={produitSelect[key]}
                                                                            onChange={(v) => {
                                                                                if (v.value === 0) {
                                                                                    confirm(
                                                                                        entities,
                                                                                        produitSelect,
                                                                                        key
                                                                                    )
                                                                                } else {
                                                                                    var e = entities;
                                                                                    var select = produitSelect;
                                                                                    e[key].idProduit = v.value;
                                                                                    e[key].designation = v.label;
                                                                                    e[key].code = v.code;
                                                                                    select[key] = v;
                                                                                    setProduitSelect(select);
                                                                                    setEntities(e);
                                                                                    setTable(e, 1);
                                                                                }
                                                                            }}
                                                                            options={optionProduit}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td>
                                                                <Form.Group>
                                                                    <Form.Control
                                                                        className="green"
                                                                        value={row.code}
                                                                        placeholder="Code"
                                                                        type="text"
                                                                        readOnly
                                                                    />
                                                                </Form.Group>
                                                            </td>
                                                            <td>
                                                                <Form.Control
                                                                    className="green"
                                                                    value={row.prix}
                                                                    placeholder="Prix"
                                                                    type="text"
                                                                    onChange={(e) => {
                                                                        var list = [...entities];
                                                                        list[key].prix = e.target.value;
                                                                        setEntities(list);
                                                                        setTable(list, 1);
                                                                    }}
                                                                />
                                                            </td>
                                                            <td>
                                                                <Button
                                                                    id={'idLigneR_' + key}
                                                                    onClick={(ev) => {
                                                                        confirmMessage(key, entities);
                                                                    }}
                                                                    variant="danger"
                                                                    size="sm"
                                                                    className="text-danger btn-link delete"
                                                                >
                                                                    <i className="fa fa-trash" id={'idLigneR_' + key} />
                                                                </Button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>



                                    </Col>

                                    <br></br>
                                    <hr></hr>
                                    <Button
                                        className="btn-fill pull-left"
                                        type="button"
                                        variant="info"
                                        nom="redac"
                                        onClick={(ev) => AjoutLigne()}
                                    >
                                        Ajouter
                                    </Button>
                                    <Col md="12">
                                        <Button
                                            id="saveBL"
                                            className="btn-wd btn-outline mr-1 float-right"
                                            type="button"
                                            variant="info"
                                            onClick={() =>
                                                saveTable(
                                                    entities,
                                                    uploadFile,
                                                    year,
                                                    month, client
                                                )
                                            }
                                        >
                                            <span className="btn-label">
                                                <i className="fas fa-check"></i>
                                            </span>
                                            Enregistrer
                                        </Button>
                                    </Col>
                                </Row>
                                {/* )} */}

                                <Row style={{ display: isLoading === 0 ? 'block' : 'none' }}>

                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
}
export default extraction_PP;
